/* eslint-disable */
module.exports = {
  flavourConfig: require('./config'),
  prod: require('./config-prod'),
};
